'use strict';

var Tablelvl2Context$1 = require('../../../../_virtual/Tablelvl2Context.js_commonjs-exports.js');
var interopRequireWildcard = require('../../../@babel/runtime/helpers/interopRequireWildcard.js');
var React$1 = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);

var _interopRequireWildcard = interopRequireWildcard;

Object.defineProperty(Tablelvl2Context$1.__exports, "__esModule", {
  value: true
});
Tablelvl2Context$1.__exports.default = void 0;

var React = _interopRequireWildcard(React__default["default"]);

/**
 * @ignore - internal component.
 */
var Tablelvl2Context = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

var _default = Tablelvl2Context;
Tablelvl2Context$1.__exports.default = _default;
